/* 
 * Export component file to be used on project
*/

import { Spinner } from './Spinner.js';
export default Spinner;
